import React from "react";
import { Drawer, List, ListItem, ListItemText, IconButton, Typography, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const Sidebar = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleNavigation = (path, openInNewTab = false) => {
    if (openInNewTab) {
      window.open(path, "_blank");
    } else {
      navigate(path);
    }
    onClose();
  };

  const menuItems = [
    { text: "Search", path: "/", openInNewTab: false },
    { text: "Export", path: "/export", openInNewTab: false },
    { text: "Petition Report", path: "/petition/reports", openInNewTab: true },
  ];

  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      <Box sx={{ width: 280, height: "100%" }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600, color: "#333" }}>
            ES Voter
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Menu Items */}
        <List sx={{ pt: 2 }}>
          {menuItems.map((item, index) => (
            <ListItem
              key={index}
              button
              onClick={() => handleNavigation(item.path, item.openInNewTab)}
              sx={{
                py: 2,
                px: 3,
                "&:hover": {
                  backgroundColor: "#e3f2fd",
                },
                ...(index === 0 && {
                  backgroundColor: "#e3f2fd",
                  borderLeft: "4px solid #1976d2",
                }),
              }}
            >
              <ListItemText
                primary={item.text}
                primaryTypographyProps={{
                  fontSize: "16px",
                  color: index === 0 ? "#1976d2" : "#666",
                  fontWeight: index === 0 ? 500 : 400,
                }}
              />
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
